import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JtsSidebarMenuService {
  serverUrl = '';
  propertyCofig: any = [];
  constructor(private http: HttpClient) {}

  getUserPreference(djjUserAcID) {
    return this.http.get(
      this.serverUrl +
        'JTSnxBllSvc/api/JTSCommon/GetUserPreference?djjUserAcID=' +
        djjUserAcID
    );
  }

  getPropertyConfig() {
    return this.http.get(this.serverUrl + 'JTSnxBllSvc/api/JTSCommon/GetPropertyConfig').subscribe((response: any) => {
      this.propertyCofig = response.filter(r => r.module === 'JTSnxCore');
    });
  }

  updateUserPreference(model) {
    return this.http.post(
      this.serverUrl + 'JTSnxBllSvc/api/JTSCommon/InsertUpdateUserPreference',
      model
    );
  }

  getJtsUserInfoGlobalAsa(userID, juvenileID) {
    return this.http.get(
      this.serverUrl +
        'JTSnxBllSvc/api/JTSUserInfoGlobalAsa/GetJtsUserInfoGlobalAsa?djjUserId=' +
        userID +
        '&juvenileID=' +
        juvenileID
    );
  }

  reportAnIssue(model) {
    return this.http.post(
      this.serverUrl + 'JTSnxBllSvc/api/ReportAnIssue/InsertReportAnIssue',
      model
    );
  }

  setAuth(tabiId, djjUserAcId) {
    return this.http.put(
      this.serverUrl +
        'JTSnxAppStateSvc/api/AppState/SetAuth?tabId=' +
        tabiId +
        '&djjUserAcid=' +
        djjUserAcId,
      {}
    );
  }

  GetAppState(tabId, userAcId) {
    return this.http.get(
      this.serverUrl +
        'JTSnxAppStateSvc/api/AppState/GetJTSnxAppState?DJJUserAcID=' +
        userAcId +
        '&TabID=' +
        tabId
    );
  }

  insertUserTractingForMainMemu(model) {
    return this.http.post(
      this.serverUrl + 'DJJEntLoggingSvc/api/UserTracking/InsertUserTracking',
      model
    );
  }

  getDemoInfoToCheck(juvenileID) {
    return this.http.get(
      this.serverUrl +
        'JTSnxBllSvc/api/AdmissionMain/GetDemoInfoToCheck?juvenileId=' +
        juvenileID
    );
  }

  getJuvenileInfo(juvenileID) {
    return this.http.get(
      this.serverUrl +
        'JTSnxBllSvc/api/JTSCommon/GetJuvenileInformation?juvenileId=' +
        juvenileID
    );
  }
}
